/* ============================================================================
   Sidenav — navegação lateral colapsável (reutilizável).
   Genérico: recebe os itens de navegação via props, então serve tanto ao
   painel admin quanto ao site do cliente.
   ============================================================================ */
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CoffeeLogo, IconLogout, IconBack } from './icons';
import './Sidenav.css';

/**
 * @param {Array<{icon: Function, label: string, path: string}>} items
 * @param {string} brandSub  subtítulo da marca (ex: "Admin" / "Aluno")
 * @param {string} homePath  rota ao clicar na marca
 * @param {Function} onLogout
 */
export default function Sidenav({ items = [], brandSub = '', homePath = '/', onLogout }) {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.body.classList.toggle('mg-nav-collapsed', collapsed);
    return () => document.body.classList.remove('mg-nav-collapsed');
  }, [collapsed]);

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <aside className={`mg-nav${collapsed ? ' is-collapsed' : ''}`}>
      <button className="mg-nav-brand" onClick={() => navigate(homePath)}>
        <span className="mg-nav-logo"><CoffeeLogo size={36} id="nav" /></span>
        <span className="mg-nav-brand-text">
          <span className="mg-nav-brand-name">Cloud Café</span>
          {brandSub && <span className="mg-nav-brand-sub">{brandSub}</span>}
        </span>
      </button>

      <nav className="mg-nav-list">
        {items.map(({ icon: Icon, label, path }) => (
          <button
            key={path}
            className={`mg-nav-item${isActive(path) ? ' is-active' : ''}`}
            onClick={() => navigate(path)}
            title={collapsed ? label : undefined}
          >
            <span className="mg-nav-item-icon"><Icon size={19} /></span>
            <span className="mg-nav-item-label">{label}</span>
          </button>
        ))}
      </nav>

      <div className="mg-nav-footer">
        <button className="mg-nav-item mg-nav-logout" onClick={onLogout} title={collapsed ? 'Sair' : undefined}>
          <span className="mg-nav-item-icon"><IconLogout size={19} /></span>
          <span className="mg-nav-item-label">Sair</span>
        </button>
        <button
          className="mg-nav-collapse"
          onClick={() => setCollapsed((v) => !v)}
          title={collapsed ? 'Expandir' : 'Recolher'}
        >
          <span className="mg-nav-item-icon" style={{ transform: collapsed ? 'rotate(180deg)' : 'none' }}>
            <IconBack size={17} />
          </span>
          <span className="mg-nav-item-label">Recolher</span>
        </button>
      </div>
    </aside>
  );
}
